import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  MenuItem,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    padding: '7px 40px 7px 26px',
  },
}));

const MenuWrapper = ({ children, onMenuClick, isChecked, label }) => {
  const classes = useStyles();

  const a11yProps = isChecked !== undefined
    ? {
        role: 'menuitemcheckbox',
        'aria-checked': isChecked,
        'aria-label': label,
      }
    : {};

  return (
    <MenuItem
      onClick={onMenuClick}
      disableGutters
      classes={{
        root: classes.root,
      }}
      {...a11yProps}
    >
      {children}
    </MenuItem>
  );
};

MenuWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  label: PropTypes.string,
};

MenuWrapper.defaultProps = {
  isChecked: undefined,
  label: undefined,
};

export default MenuWrapper;
